import { Box } from "@mui/material";
import { isNil } from "lodash";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../core/app/AppReducer";
import { ItemLightDto } from "../../../core/items/ItemDataTypes";
import { setItems as setItemsGlobal } from "../../OotrReducer";


export interface DbItemProps {
    items?: ItemLightDto[] | undefined
    update?: (v:ItemLightDto) => void
}


export interface OotItemProps {
    id: string
    children: (v: ItemChildProps) => JSX.Element
    items?: Array<ItemLightDto>,
    onClick?: (v: ItemLightDto) => void
}

export interface ItemChildProps {
    updateOotItem: (item: ItemLightDto | undefined) => void
    item: ItemLightDto | undefined
}

const OotItem = (props: OotItemProps) => {

    let { id } = props;

    let dispatch = useDispatch();


    let globalItems = useSelector((state: AppState) => state.ui.ootr.main.items)

    let setItems =  setItemsGlobal


    let items = !isNil(props.items) ? props.items :  globalItems

    let item = items?.find(i => i.id === id)

    useEffect(() => {

        if (isNil(item)) {
            dispatch(setItems({ id: id, isObtained: false, state: 0, title: id } as ItemLightDto))
        }
    })


    const updateItem = (item: ItemLightDto | undefined) => {
        if (!isNil(item))
            dispatch(setItems(item))
    }

    return <Box display="flex" position="relative">
        {(props.children({ updateOotItem: updateItem, item: item }))}
    </Box>
}

export default OotItem